import React, { useTransition } from 'react'

import { EntityPreview } from 'src/editor/shared/components/entity-preview'
import { SettingsNestedMenu } from 'src/editor/layout/sidebar/settings/settings-nested-menu'
import { WebsiteTypographyGroup } from '../entity-and-website-typography-group/website-typography-group'
import {
  WebsiteFormFieldsSettings,
  WebsiteSettingsTypographyTypeEnum,
} from 'src/shared/types/website-settings-types'
import { WebsiteBorderGroup } from '../border-groups/website-border-group'
import {
  updateWebsiteStylesFormFieldBorder,
  updateWebsiteStylesFormFieldTypography,
} from 'src/editor/store/website-settings/website-settings-actions'
import { ButtonAndFormFieldStyleGroup } from '../../groups/button-and-form-field-style'
import { useThemeColor } from 'src/editor/shared/hooks/use-theme-color'
import CommonField from 'common/components/entities/Field/FieldUi'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { PaddingType } from 'common/types/styleTypes'
import { formFieldsColorKeys } from 'src/editor/layout/sidebar/website-styles-settings/consts'
import { useCurrentTheme } from 'src/editor/layout/sidebar/website-styles-settings/hooks/useCurrentTheme'
import { ColorPickerGroup } from '../../groups/color-picker'

interface WebsiteFormFieldGroupProps {
  updateWebsiteStylesFormField: <Key extends keyof WebsiteFormFieldsSettings>(
    prop: Key,
  ) => (value: WebsiteFormFieldsSettings[Key]) => void
  formFieldSettings: WebsiteFormFieldsSettings
}

export const WebsiteFormFieldGroup = ({
  updateWebsiteStylesFormField,
  formFieldSettings,
}: WebsiteFormFieldGroupProps) => {
  const { formFields } = useThemeColor()
  const { t } = useTypedTranslation()

  return (
    <>
      <EntityPreview>
        <CommonField
          fontFamily={formFieldSettings?.typography?.fontFamily}
          placeholder={t('website_styles_settings.text_example')}
          padding={
            (formFieldSettings?.padding as PaddingType) || {
              paddingBottom: 0,
              paddingTop: 0,
              paddingLeft: 0,
              paddingRight: 0,
            }
          }
          lineHeight={formFieldSettings?.typography?.lineHeight}
          // mobileLineHeight={calculatedLineHeight}
          textAlign={formFieldSettings?.typography?.textAlign}
          // mobileTextAlign={formFieldSettings.typography.mobileTextAlign}
          border={{
            ...formFieldSettings.border,
            color: formFields?.formFieldBorderColor,
          }}
          // mobileBorder={formFieldSettings.border}
          color={formFields?.formFieldTextColor}
          fontSize={formFieldSettings?.typography?.fontSize}
          backgroundColor={formFields?.formFieldBackgroundColor}
        />
      </EntityPreview>
      <ButtonAndFormFieldStyleGroup
        updateWebsiteStyles={updateWebsiteStylesFormField}
        styleSettings={formFieldSettings}
        type={WebsiteSettingsTypographyTypeEnum.FormField}
      />
      <WebsiteBorderGroup
        stylesObject={formFieldSettings as WebsiteFormFieldsSettings}
        updateBorderAction={updateWebsiteStylesFormFieldBorder}
      />
      <SettingsNestedMenu menuButtonLabel="Typography" menuTitle="Typography">
        <WebsiteTypographyGroup
          typographyObject={formFieldSettings.typography}
          updateTypographyAction={updateWebsiteStylesFormFieldTypography}
          hideTitle
          hideLetterSpacing
          isFirst
        />
      </SettingsNestedMenu>
      <SettingsNestedMenu menuButtonLabel="Colors" menuTitle="Colors">
        <ColorPickerGroup
          elementKey="formFields"
          colorKeys={formFieldsColorKeys}
        />
      </SettingsNestedMenu>
    </>
  )
}
